<template>
  <div class="liu">
    <mt-header fixed :title="title" class="title1">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight" v-infinite-scroll="getMoreMyData" :infinite-scroll-disabled="myData.scrollDisabled" infinite-scroll-distance="0">
      <!-- 空页 -->
      <div v-if="isShowEmptyData"></div>
      <!-- 列表 -->
      <div v-if="isShowListData" style="margin: 15px 0 50px 0">
        <div class="agent-info-box" v-for="(item, index) in myData.list" :key="index">
          <div class="agent-info">
            <div class="agent-user">
              <div class="agent-check" @click.stop="onSelectedCheckClick(item, index)">
                <svg-icon :icon-class="selectedCheckSvgPath(item)" class-name="cur-icon"></svg-icon>
              </div>
              <div>
                <div class="lh1">
                  <span class="agent-name">费率：{{ item.fee | formatRateForShow }}（万分之）</span>
                </div>
                <div class="agent-date lh1">
                  <span>邀请码名称：{{ item.remarkName | shortName }}</span>
                </div>
              </div>
            </div>
            <div class="agent-collapse" @click="showRegQRCode(item)">
              <div class="btn-div">
                <span class="btn-span">查看邀请码 ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 无数据占位图 -->
      <div v-if="isShowNoData">
        <div class="no-data">
          <img src="../../assets/bitmap_agent@3x.png" width="60%" />
        </div>
      </div>
      <!-- 按钮 无数据时 -->
      <div class="btn pageBtn" v-if="isShowNoData">
        <mt-button type="primary" size="large" @click="addNewQRCode">
          新增邀请码
        </mt-button>
      </div>
      <!-- 按钮 列表有数据时 -->
      <div class="more-button" v-if="isShowListData">
        <span class="blue" @click="addNewQRCode">新增邀请码</span>
        <span class="white" @click="removeQRCode">删除邀请码</span>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';
import { CusToast, CusLoadingOpen, CusLoadingClose, CusAlert, CusConfirm } from '@/utils/CustomToast';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { ModifiedCustomerInviteCode, QueryCustomerInviteCodeList, GetCurrentAgentFee } from '@/api/customer';
export default {
  name: 'PosManageSelfRegFeeList',
  comments: { SvgIcon },
  data() {
    return {
      title: '自助注册邀请码列表',
      // 列表数据模型
      myData: {
        list: [],
        total: -1,
        scrollDisabled: true,
        selectedItem: null,
        agentInfo: '', // 代理商名+手机号
        regLink: '', // 注册链接
      },
      hasSelectedQR: false,
      myParam: {
        // 列表查询参数
        pageNum: 1,
        pageSize: 10,
      },
      getRateCodeErrMsg: '', // 获取费率异常
      tmp: {
        minFee: 0,
        maxFee: 0,
      },
    };
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    isShowListData() {
      return this.myData.total > 0;
    },
    isShowEmptyData() {
      return this.myData.total === -1;
    },
    isShowNoData() {
      return this.myData.total === 0;
    },
    selectedCheckSvgPath() {
      return item => (item.selected ? 'selected_coupons' : 'unselected_coupons');
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.myData.list = [];
    this.myParam.pageNum = 1;
    this.$nextTick(() => {
      this.getMyData();
    });
  },
  methods: {
    // 邀请码列表查询
    getMyData() {
      CusLoadingOpen();
      // 先设置禁止滚动加载数据
      this.myData.scrollDisabled = true;
      const data = {
        pageNum: this.myParam.pageNum,
        pageSize: this.myParam.pageSize,
      };
      QueryCustomerInviteCodeList(data)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusLoadingClose();
              // 只在第一次加载列表时存储下total的值，以后不再存储
              this.myData.list.length === 0 && (this.myData.total = res.total);
              this.myData.list.length === 0 && (this.myData.agentInfo = res.data.agentInfo);
              this.myData.list.length === 0 && (this.myData.regLink = res.data.regLink);
              // 通过记录条数list.length和数据总数total判断是否查询出所有数据
              // 如果记录条数小于数据总数，则证明没有查询出所有数据，设置允许滚动加载数据
              if (this.myData.list.length < this.myData.total) {
                this.myData.scrollDisabled = false;
              }
              this.myData.list.push(...res.data.inviteCodeDataList);
            },
            (code, msg) => {
              CusLoadingClose();
              this.myData.total = -1;
              this.myParam.pageNum = 1;
              this.myData.scrollDisabled = true;
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取代理商费率 此页面暂时不调用此接口
    getCurrentAgentFee(callback = null) {
      GetCurrentAgentFee()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.tmp.minFee = res.data.fee;
              this.tmp.maxFee = res.data.maxFee;
              CusLoadingClose();
              callback && callback();
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
              this.getRateCodeErrMsg = msg;
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
          this.getRateCodeErrMsg = msg;
        });
    },
    // 返回单击事件
    onBackBtnClick() {
      // this.$router.go(-1);
      this.$router.push({ path: '/posmanagemodule/index' });
    },
    // 选中邀请码的checkbox的click事件
    onSelectedCheckClick(item, index) {
      // 设置选中状态;
      this.myData.list[index].selected = !this.myData.list[index].selected;
      // 其他项都设为false;
      for (const i in this.myData.list) {
        parseInt(i) !== index && (this.myData.list[i].selected = false);
      }
      // 根据状态储存数据
      this.myData.selectedItem = this.myData.list[index].selected ? this.myData.list[index] : null;
      // 设置删除按钮状态
      let selectedCount = 0;
      this.myData.list.forEach(row => row.selected && (selectedCount += 1));
      // 判断计数器
      // 如果大于0，则证明有选中的，让按钮可用
      this.hasSelectedQR = selectedCount > 0;
      // 重新渲染组件
      this.$forceUpdate();
    },
    // 新增邀请码
    addNewQRCode() {
      if (this.getRateCodeErrMsg) {
        CusToast(this.getRateCodeErrMsg);
        return;
      }
      this.$router.push({ path: '/posmanagemodule/selfregfeeedit' });
    },
    // 查看邀请码
    showRegQRCode(item) {
      this.$router.push({
        path: '/posmanagemodule/qrcodeshow',
        query: {
          fee: item.fee,
          name: item.remarkName,
          id: item.id,
          pId: item.productAgentId, // 代理商id
          info: this.myData.agentInfo, // 代理商名+手机号
          link: this.myData.regLink,
        },
      });
    },
    // 删除邀请码
    removeQRCode() {
      if (!this.hasSelectedQR) {
        CusToast('请选择要删除的邀请码');
        return;
      }
      CusConfirm('确定删除此邀请码？', () => {
        this.modifiedCustomerInviteCode();
      });
    },
    // 删除邀请码
    modifiedCustomerInviteCode() {
      CusLoadingOpen();
      const data = {
        id: this.myData.selectedItem.id,
      };
      ModifiedCustomerInviteCode(data)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusLoadingClose();
              CusAlert('删除成功', () => {
                // 滚动条置顶
                window.scrollTo(0, 0);
                // 重置列表数据
                this.myData.list = [];
                // 重置总数
                this.myData.total = -1;
                this.myParam.pageNum = 1;
                // 加载数据
                this.getMyData();
              });
            },
            (code, msg) => {
              CusLoadingClose();
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 自动加载获取更多数据
    getMoreMyData() {
      // 通过记录条数list.length和数据总数total判断是否查询出所有数据
      // 如果记录条数小于数据总数，则证明没有查询出所有数据
      if (this.myData.list.length && this.myData.list.length < this.myData.total) {
        this.myParam.pageNum += 1;
        this.getMyData();
      }
    },
  },
  filters: {
    formatRateForShow(val) {
      val = String(val).trim();
      val = isNaN(parseFloat(val)) ? 0 : parseFloat(val);
      return parseFloat(val * 10000).toFixed(2);
    },
    shortName(val) {
      return val.length > 7 ? `${val.substr(0, 7)}…` : val;
    },
  },
};
</script>

<style lang="scss" scoped>
.agent-info-box {
  &:nth-child(1) {
    margin-top: 0;

    &.tmp-top {
      margin-top: 2.3rem;
    }
  }

  &:nth-child(2) {
    margin-top: 0.75rem !important;
    background-color: #fff;
  }

  .agent-info {
    .lh1 {
      line-height: 1;
    }

    .agent-date {
      margin-left: 0.6rem;
      padding-top: 0.25rem;
      text-align: left;
    }

    .pt25 {
      padding-top: 0.25rem;
    }
  }
}
.pageBtn {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
